<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Caching from "@/services/Caching";
import Swal from "sweetalert2";
import Aws from "@/services/Aws";
import Monitor from "@/services/Monitor";
import ModalViewRedisKeyDetails from "@/components/modals/monitor/modalViewRedisKeyDetails";

export default {
  components: {
    Layout,
    PageHeader,
    ModalViewRedisKeyDetails
  },
  page: {
    title: "Caching",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      error: null,
      tableData: [],
      title: "Caching",
      items: [
        {
          text: "Monitor",
        },
        {
          text: "Caching",
          active: true,
        },
      ],
      filterInput: {},
      isBusy: false,
      chart1Loader: false,
      chart2Loader: false,
      responseRedisHitsMissesWidget: '',
      responseCurrItemsWidget: '',
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      selectedTenant: '',
      tenants: [],
      allSelected: false,
      filterOn: [],
      sortBy: "key",
      selectedKeys: [],
      filteredItems: [],
      keyData: [],
      sortDesc: true,
      fields: [
        {
          key: 'selected',
          label: '',
          thStyle: { width: '40px' }
        },
        {
          key: "key",
          label: "Key",
          visible: true,
          sortable: false,
        },
        {
          key: "action",
          label: "Action",
        }
      ],
      filterData: false,
      loading: false,
      isDeletingKeys: false,
    };
  },

  async created() {
    await this.getTenants()
    await this.getRedisCharts()
    await this.getKeys()
  },
  methods: {
    updateAllSelectedState() {
      const filteredKeys = this.filteredItems.map(item => item.key);
      this.allSelected = filteredKeys.every(key => this.selectedKeys.includes(key));
    },

    onFiltered(filteredItems) {
      this.filteredItems = filteredItems;
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
      this.updateAllSelectedState();
    },

    getRedisCharts(){

      this.chart1Loader = true

      Aws.getRedisCharts().then((response) => {
        this.responseRedisHitsMissesWidget= response.data.data.hitsMissesWidget;
        this.responseCurrItemsWidget= response.data.data.currItemsWidget;
      }).catch((error) => {
        this.errorCharts = error.response.data.error
            ? error.response.data.error
            : "";
      }).finally(() => {
        this.chart1Loader = false
      });
    },

    async getKeys() {
      try {
        this.filterData = true;
        this.isBusy = true;

        const q = encodeURIComponent(this.selectedTenant || "");
        const search = `q=${q}`;

        const response = await Caching.getKeys(search);
        this.tableData = response.data.data;
        this.totalRows = this.tableData.length;
        this.isBusy = false;
      } catch (error) {
        this.isBusy = false;
        this.error = error.response?.data?.error || "An error occurred while fetching data.";
        this.tableData = [];
        this.totalRows = 0;
      }
    },

    removeAllKeys() {
      if (!this.selectedTenant) {
        this.failedmsg("Fail!", "Please select a tenant first.");
        return;
      }

      Swal.fire({
        title: `Delete ALL cache keys for tenant "${this.selectedTenant}"?`,
        text: "This will remove every matching Redis key for this tenant and cannot be undone.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete all!",
      }).then(async (result) => {
        if (result.isConfirmed || result.value) {
          this.isDeletingKeys = true;
          try {
            const response = await Caching.deleteAllKeys(this.selectedTenant);
            const res = response.data.data.success ? response.data.data.success : false;
            const error = response.data.error ? response.data.error : 'Failed';
            if (res) {
              await this.getKeys();
              this.selectedKeys = [];
              this.allSelected = false;
              this.successmsg("Removed!", "All cache keys for this tenant were removed!");
            } else {
              this.failedmsg("Fail!", error);
            }
          } catch (error) {
            const resData = error.response?.data?.error ? error.response.data.error : 'Failed';
            this.failedmsg("Fail!", resData);
          } finally {
            this.isDeletingKeys = false;
          }
        }
      });
    },

    removeKey(){
      Swal.fire({
        title: "Are you sure you want to delete selected key(s)?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.isConfirmed || result.value) {
          const params = {
            key: this.selectedKeys
          };

          this.isDeletingKeys = true;
          try {
            const response = await Caching.deleteKey(params);
            const res = response.data.data.success ? response.data.data.success : false;
            const error = response.data.error ? response.data.error : 'Failed';
            if (res) {
              await this.getKeys();
              this.selectedKeys = [];
              this.successmsg("Removed!", "Cache Key(s) Removed!");
            } else {
              this.failedmsg("Fail!", error);
            }
          } catch (error) {
            const resData = error.response?.data?.error ? error.response.data.error : 'Failed';
            await this.getKeys();
            this.failedmsg("Fail!", resData);
          } finally {
            this.isDeletingKeys = false;
          }
        }
      });
    },

    async viewKeyDetails(key) {
      const encodedKey = encodeURIComponent(key);
      this.$bvModal.show("viewRedisKeyDetails");
      this.keyData = encodedKey;
    },

    copyValue(token) {
      navigator.clipboard.writeText(token)
          .then(() => {
            this.showToast('Copied to clipboard');
          })
          .catch(err => {
            console.error('Error copying data:', err);
            this.showToast('Failed to copy data');
          });
    },

    showToast(message) {
      this.toastMessage = message; // Set the message
      setTimeout(() => {
        this.toastMessage = null; // Clear the message after 3 seconds
      }, 3000);
    },

    toggleSelectAll() {
      // Determine which items are currently visible or filtered
      let currentItems = this.tableData;

      // If a filter is applied, filter the tableData manually
      if (this.filter && this.filter.trim() !== '') {
        const filterValue = this.filter.toLowerCase();
        currentItems = currentItems.filter(item => {
          return Object.values(item).some(value =>
              String(value).toLowerCase().includes(filterValue)
          );
        });
      }

      const currentKeys = currentItems.map(item => item.key);

      if (this.allSelected) {
        // Unselect all filtered or visible items
        this.selectedKeys = this.selectedKeys.filter(key => !currentKeys.includes(key));
        this.allSelected = false;
      } else {
        // Select all filtered or visible items
        const unique = new Set([...this.selectedKeys, ...currentKeys]);
        this.selectedKeys = Array.from(unique);
        this.allSelected = true;
      }
    },

    getTenants() {
      Monitor.getTenants()
          .then((response) => {
            this.tenants = response.data.tenants;
          })
          .catch((error) => {});
    },

  },
  middleware: "authentication",
  watch: {
    selectedTenant() {
      this.getKeys()
    }
  }
};

</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" :fields="fields"/>
    <div class="row">

      <div class="col-12">

        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <button class="btn btn-primary" @click="getRedisCharts()">
                  <i class="uil uil-refresh"></i>
                  Reload Charts
                </button>
              </div>
              <!-- Chart 1 -->
              <div class="col-6 position-relative chart-container">
                <div :class="{ 'chart-overlay': chart1Loader }">
                  <img v-if="responseRedisHitsMissesWidget" :src="responseRedisHitsMissesWidget" alt="Hits & Misses Widget" class="img-fluid">
                </div>
                <div v-if="chart1Loader" class="spinner-overlay">
                  <b-spinner large></b-spinner>
                </div>
              </div>

              <div class="col-6 position-relative chart-container">
                <div :class="{ 'chart-overlay': chart1Loader }">
                  <img v-if="responseCurrItemsWidget" :src="responseCurrItemsWidget" alt="Current Items Widget" class="img-fluid">
                </div>
                <div v-if="chart1Loader" class="spinner-overlay">
                  <b-spinner large></b-spinner>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="card" v-show="filterData">
          <div class="card-body">

            <div class="row mt-4">
              <div class="col-md-2 d-inline-flex align-items-center">
                <h4 class="card-title m-0">Total Keys: {{ totalRows }}</h4>
              </div>
              <div class="col-md-4 d-inline-flex align-items-center">
                  <label class="control-label form-label" style="width: 180px">Filter by Tenant</label>
                  <select
                      v-model="selectedTenant"
                      class="form-control form-select"
                      name="option"
                      type="select"
                  >
                    <option value="" key=""></option>
                    <option v-for="tenant in tenants" :key="tenant" :value="tenant">
                      {{ tenant }}
                    </option>
                  </select>
              </div>

              <div class="col-sm-12 col-md-3 d-inline-flex align-items-center">
                <div class=" " v-show="filterData">
                  <button
                      class="btn btn-secondary btn-sm me-2"
                      @click="toggleSelectAll"
                      :disabled="!tableData.length"
                  >
                    <i class="uil uil-check-square"></i>
                    {{ allSelected ? 'Deselect All' : 'Select All' }}
                  </button>

                  <button
                      class="btn btn-danger btn-sm"
                      :disabled="!selectedKeys.length || isBusy || isDeletingKeys"
                      @click="removeKey"
                  >
                    <i class="uil uil-trash-alt"></i> Delete Selected ({{ selectedKeys.length }})
                  </button>

                  <button
                      class="btn btn-danger btn-sm ms-2"
                      :disabled="!selectedTenant || isBusy || isDeletingKeys"
                      @click="removeAllKeys"
                  >
                    <i class="uil uil-trash-alt"></i> Delete All
                  </button>
                </div>
              </div>

            </div>
            <div class="row mt-4" v-show="filterData">
              <div class="col-sm-12 col-md-3">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>

              <!-- Search -->
              <div class="col-sm-12 col-md-9">
                <div id="deals-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0" v-show="filterData">
              <b-table
                  :items="tableData"
                  :busy="isBusy"
                  :fields="fields"
                  :visible="fields.visible"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
                  show-empty
                  empty-text="No Data Found"
              >
                <template #cell(selected)="data">
                  <input
                      type="checkbox"
                      :value="data.item.key"
                      v-model="selectedKeys"
                  />
                </template>

                <template v-slot:cell(action)="data">
                  <ul class="list-inline mb-0">
                    <li class="list-inline-item">
                      <a href="javascript:void(0);" class="px-2 text-primary" title="Key Details" @click="viewKeyDetails(data.item.key)">
                        <i class="uil uil-eye font-size-18"></i>
                      </a>
                    </li>

<!--                    <li class="list-inline-item">
                     <a href="javascript:void(0);" class="px-2 text-danger" title="Remove Key" @click="removeKey(data.item.key)">
                        <i class="uil uil-trash-alt font-size-18"></i>
                      </a>
                    </li>-->
                  </ul>
                </template>

                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>

              </b-table>
            </div>
            <!--Table end -->

            <div class="row" v-show="filterData">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!-- MODALS -->
    <ModalViewRedisKeyDetails :keyData="keyData"></ModalViewRedisKeyDetails>
    <!-- /MODALS -->
  </Layout>
</template>